import axios from "@/http/api";
import config from "@/http/config";
// 上传图片
export const fileUploadImage = data =>
  axios({
    url: config.baseUrl + "/upload/img/notification", // path路径
    method: "POST", // 请求方法
    headers: {
      // 请求头
      Authorization: localStorage.getItem("access_token")
    },
    data // 请求体
  });
